<div class="form-container">
    <h2 style="margin-bottom: 43px; margin-top: 0px;" class="font-semibold text-xl">Tyre & battery details</h2>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
      <button type="submit" pButton [disabled]="form.invalid"  class="custom-upload-button  btn-primary">
        Next
        <i class="pi pi-arrow-right arrow-icon" style="margin-left: 8px;"></i>
      </button>
    </form>
  </div>